import { render, staticRenderFns } from "./semi_final_form_code.vue?vue&type=template&id=976b6b04&scoped=true"
import script from "./semi_final_form_code.vue?vue&type=script&lang=js"
export * from "./semi_final_form_code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976b6b04",
  null
  
)

export default component.exports